import _ from 'lodash';

type EnsureNoNull<T> = T extends null ? never : T;

export const omitNullableValues = <O extends {}>(input: O) => {
  const output = { ...input };
  Object.keys(input).forEach(k => {
    const value = output[k as keyof O];
    if (_.isNil(value)) delete output[k as keyof O];
  });
  return {
    ...output,
  } as {
    [K in keyof O]: EnsureNoNull<O[K]>;
  };
}
